<!-- 
  <nz-carousel nzAutoPlay [nzAutoPlaySpeed]="'3000'">
    <div nz-carousel-content *ngFor="let index of array">
        <img loading="lazy" src="{{index.image}}" alt="Third slide">
    </div>
  </nz-carousel> -->

  <!-- <div id="carouselExample" class="carousel slide" data-ride="carousel" data-interval="2500">
    <ol class="carousel-indicators">
      <li data-target="#carouselExample" data-slide-to="{{ i }}" class="carousel_slider_indicator" [ngClass]="{'active': i==0}" *ngFor="let index of get_all_product_banner_response; let i = index"></li>
    </ol>
    <div class="carousel-inner" [ngStyle]="{'height': (height ? height : 'inherit' )}">
      <div class="carousel-item" [ngClass]="{'active': i==0}" *ngFor="let index of get_all_product_banner_response; let i = index">
        <img loading="lazy" class="d-block w-100 carousel_slider_img" src="{{imgUrl}}{{ index.image }}" alt="{{i}} First slide">
      </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExample" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExample" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div> -->

<app-my-carousel-swiper class="carousel-banner-shop" [slide]="get_all_product_banner_response" [config]="carouselOptions">
  <div class="swiper-slide" *ngFor="let image of get_all_product_banner_response; let i = index">
    <img loading="lazy" [src]="imgUrl + image.image" alt="{{ i }} First slide" />
  </div>
</app-my-carousel-swiper>
